export enum DataOrigin{
    Mobile = 'mobile',
    Caronte = 'caronte',
    Mock = 'mock'
}